/* ============================================
   Artemis Theme — Apparel PDP
   ============================================
   "Add to Designer" wiring for apparel product
   pages. Captures the selected color, snapshots
   the product into the designer session, shows
   a toast, and updates the floating badge.
   ============================================ */

(function () {
  'use strict';

  if (!window.DesignerSession) return;

  var snapshot = window.PDP_PRODUCT_SNAPSHOT;
  if (!snapshot) return;

  var colorSelect = document.querySelector('[data-apparel-color]');
  var addBtn = document.querySelector('[data-apparel-add]');
  var stockEl = document.querySelector('[data-apparel-stock]');
  var badge = document.querySelector('[data-designer-badge]');
  var badgeCount = document.querySelector('[data-designer-badge-count]');
  var designerUrl = (badge && badge.getAttribute('href')) || '/pages/apparel-designer';

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var STATUS_TEXT = { in: 'In stock', low: 'Low stock', out: 'Out of stock' };

  // Currently selected color, falling back to the first variant's color.
  function selectedColor() {
    if (colorSelect && colorSelect.value) return colorSelect.value;
    if (!window.ApparelStock) return '';
    var ci = window.ApparelStock.colorIndexOf(snapshot);
    var first = snapshot.variants && snapshot.variants[0];
    return (ci >= 0 && first && first.options) ? first.options[ci] : '';
  }

  // Render the per-size availability grid for the selected color and gate the
  // "Add to Designer" button when every size in that color is sold out.
  function renderStock() {
    if (!stockEl || !window.ApparelStock) return;
    var color = selectedColor();
    var sizes = window.ApparelStock.sizesForColor(snapshot, color);
    if (!sizes.length) {
      stockEl.setAttribute('hidden', '');
      setSoldOut(false);
      return;
    }

    var allOut = sizes.every(function (s) { return s.status === 'out'; });
    var cells = sizes.map(function (s) {
      return '<span class="apparel-stock__size apparel-stock__size--' + s.status + '">' +
        '<span class="apparel-stock__size-name">' + escapeHtml(s.size) + '</span>' +
        '<span class="apparel-stock__size-status">' + STATUS_TEXT[s.status] + '</span>' +
      '</span>';
    }).join('');

    stockEl.innerHTML =
      '<div class="apparel-stock__head">Availability' +
        (color ? ' — ' + escapeHtml(color) : '') + '</div>' +
      '<div class="apparel-stock__grid">' + cells + '</div>' +
      (allOut ? '<p class="apparel-stock__sold-out">This color is sold out in every size.</p>' : '');
    stockEl.removeAttribute('hidden');
    setSoldOut(allOut);
  }

  function setSoldOut(soldOut) {
    if (!addBtn) return;
    addBtn.disabled = !!soldOut;
    addBtn.classList.toggle('product-page__add-to-cart--disabled', !!soldOut);
    if (soldOut) {
      addBtn.setAttribute('aria-disabled', 'true');
      if (!addBtn.dataset.label) addBtn.dataset.label = addBtn.textContent;
      addBtn.textContent = 'Sold out in this color';
    } else {
      addBtn.removeAttribute('aria-disabled');
      if (addBtn.dataset.label) {
        addBtn.textContent = addBtn.dataset.label;
        delete addBtn.dataset.label;
      }
    }
  }

  function refreshBadge() {
    var n = window.DesignerSession.count();
    if (!badge) return;
    if (n > 0) {
      badge.removeAttribute('hidden');
      if (badgeCount) badgeCount.textContent = String(n);
      badge.setAttribute('data-count', String(n));
    } else {
      badge.setAttribute('hidden', '');
    }
  }

  function showToast(message, linkUrl, linkLabel) {
    var existing = document.querySelector('[data-designer-toast]');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'designer-toast';
    toast.setAttribute('data-designer-toast', '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    var msg = document.createElement('span');
    msg.className = 'designer-toast__message';
    msg.textContent = message;
    toast.appendChild(msg);

    if (linkUrl) {
      var link = document.createElement('a');
      link.className = 'designer-toast__link';
      link.href = linkUrl;
      link.textContent = linkLabel || 'View';
      toast.appendChild(link);
    }

    document.body.appendChild(toast);
    requestAnimationFrame(function () {
      toast.classList.add('designer-toast--visible');
    });
    setTimeout(function () {
      toast.classList.remove('designer-toast--visible');
      setTimeout(function () { toast.remove(); }, 250);
    }, 4000);
  }

  if (addBtn) {
    addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      var color = colorSelect ? colorSelect.value : '';
      window.DesignerSession.add({
        productHandle: snapshot.handle,
        productId: snapshot.id,
        color: color,
        productSnapshot: snapshot,
      });
      showToast('Added to designer', designerUrl, 'Open Apparel Designer →');
      refreshBadge();
    });
  }

  if (colorSelect) {
    colorSelect.addEventListener('change', renderStock);
  }

  window.DesignerSession.on('change', refreshBadge);
  refreshBadge();
  renderStock();
})();
